<template>
  <div class="page-content">
    <div class=" own-title margin-bottom-20">
      My Potential Income
    </div>
    <div class="content card round-medium bg-color">
      <div class="divider-margins"></div>
      <div class="content">
        <h5 class="text-left">1st Year Premium (RM)</h5>
        <div class="input-style input-style-1 input-required">
          <input type="number" placeholder="138,000" name="amount" id="amount" class="input-area" value="138000">
        </div>
        <div class="checkboxes-demo">
          <div class="fac fac-radio-full fac-default"><span></span>
            <input id="box1-fac-radio-full" class="amount_value" type="radio" name="amount_value" value="68000">
            <label for="box1-fac-radio-full">68,000</label>
          </div>
          <div class="fac fac-radio-full"><span></span>
            <input id="box2-fac-radio-full" class="amount_value" type="radio" name="amount_value" value="138000" checked="checked">
            <label for="box2-fac-radio-full">138,000</label>
          </div>
          <div class="fac fac-radio-full"><span></span>
            <input id="box3-fac-radio-full" class="amount_value" type="radio" name="amount_value" value="208000">
            <label for="box3-fac-radio-full">208,000</label>
          </div>
          <div class="fac fac-radio-full"><span></span>
            <input id="box5-fac-radio-full" class="amount_value" type="radio" name="amount_value" value="308000">
            <label for="box5-fac-radio-full">308,000</label>
          </div>
        </div>
      </div>
      <div class="divider-margins"></div>
      <div class="content">
        <h5 class="text-left">Growth Rate (%)</h5>
        <div class="input-style input-style-1 input-required">
          <span class="input-style-1-inactive">Rate</span>
          <input type="number" placeholder="20" name="rate" id="rate" class="input-area" value="20">
        </div>
        <div class="checkboxes-demo">
          <div class="fac fac-radio-full fac-default"><span></span>
            <input id="percent10" type="radio" name="rate_value" class="rate_value" value="10">
            <label for="percent10">10%</label>
          </div>
          <div class="fac fac-radio-full"><span></span>
            <input id="percent20" type="radio" name="rate_value" class="rate_value" value="20" checked="checked">
            <label for="percent20">20%</label>
          </div>
          <div class="fac fac-radio-full"><span></span>
            <input id="percent30" type="radio" name="rate_value" class="rate_value" value="30">
            <label for="percent30">30%</label>
          </div>
          <div class="fac fac-radio-full"><span></span>
            <input id="percent40" type="radio" name="rate_value" class="rate_value" value="40">
            <label for="percent40">40%</label>
          </div>
        </div>
      </div>
      <div class="divider-margins"></div>
      <div class="content">
        <h5 class="text-left">ILP / Traditional Product (%)</h5>
        <div class="input-style input-style-1 input-required">
          <span class="input-style-1-inactive">Rate</span>
          <div class="input-group">
            <input type="number" placeholder="0" name="ilp_rate" id="ilp_rate" class="input-area one-half">
            <input type="number" placeholder="0" name="tranditional_rate" id="tranditional_rate" class="input-area one-half last-column">
          </div>
          <div class="remark-text text-left ">
            Income calculations based on 100% Persistency Ratio
          </div>
        </div>
      </div>
      <div class="divider-margins"></div>
  
      <div class="content" id="divider-result">
        <input type="submit" class="button button-m button-red round-huge shadow-huge bottom-0 button-center-medium"  value="enter" id="enter" data-formid="contactForm">
        <input type="submit" class="button button-m button-line round-huge bottom-0 button-center-medium"  value="reset" id="reset" data-formid="contactForm">
      </div>
   
      <div class="content padding-30" id="result">
        <table class="income">
          <tr>
            <th>Year</th>
            <th>Annual Income (RM)</th>
          </tr>
          <tr>
            <td>1st Year</td>
            <td id="1st-year-value">21,500.00</td>
          </tr>
          <tr>
            <td>2nd Year</td>
            <td id="2nd-year-value">44,150.00</td>
          </tr>
          <tr>
            <td>3rd Year</td>
            <td id="3rd-year-value">63,565.00</td>
          </tr>
          <tr>
            <td>4th Year</td>
            <td id="4th-year-value">84,921.00</td>
          </tr>
          <tr>
            <td>5th Year</td>
            <td id="5th-year-value">103,413.00</td>
          </tr>
          <tr>
            <td>6th Year</td>
            <td id="6th-year-value">317,550.00</td>
          </tr>
          <tr>
            <td>Total 6-year Income (RM)</td>
            <td id="total-value">412,000.00</td>
          </tr>
        </table>
        <div class="graph-area">
          <div class="gragh-area-content">
            <p class="left-text under-heading graph-area-text bottom-15"><span class="icon icon-xs shadow-huge-box"><i class="fa"></i></span>Projected Annual Income for the first 6-year</p>
            <div class="content">
              <canvas class="chart" id="result_table" />
            </div>
          </div>
        </div>
        <p class="text-left declaration remark-text">* The indicative income as above is just an illustration</p>
        <p class="text-left remark-text">* This is mainly on basic commision earn only</p>
        <p class="text-left remark-text">* Projection based on total commission without consider the effect of BSC</p>
      <div class="divider-margins"></div>
      <div class="content">
        <input type="submit" class="button button-m button-red round-huge shadow-huge bottom-0 button-center-medium" value="Calculate Again" id="again" data-formid="contactForm">
      </div>
      </div>
      <div class="divider-margins"></div>
    </div>
    
  </div>
</template>
<style scoped>
  .checkboxes-demo .fac {
    display: inline-block;
  }

  .graph-area-text{
    font-size: 15px;
  }

  h5{
    color: #6D6D6D;
  }

 
  #divider-result{
    display: flex;
    flex-direction: column;
  }

  #enter {
    order: 0;
  }

  #reset {
    order: 1;
  }
.bg-color{
  background-color: rgb(255, 255, 255,0.7)
}

  .fac>input+label:before,
  .fac>span::after {
    color: #1b1d21;
  }

  .fac label {
    border: 1px solid #DADAD9;
    padding: 10px 15px;
    border-radius: 10px;
    min-width: 100px;
    margin-right: 50px;
    background-color: #ffffff;
    color: #7A7B7A !important;
  }

  .fac-checkbox>input:checked+label,
  .fac>input:checked+label {
    /* background-color: #047180; */
    background-color: #DADAD9;
    color: #000000 !important;
  }

  .button-line{
    color: #6D6D6D;
    box-shadow: none !important;
  }

  .fac-radio-full>input[type=radio]+label:before {
    content: "";
  }

  .checkboxes-demo {
    display: inline-flex;
  }

  input[type=number] {
  color: #6c6c6c !important;
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #6c6c6c !important;
  opacity: 1; /* Firefox */
}

  .input-area {
    /* padding: 0 12px;
    background-color: #000000; */
    padding: 0 12px;
    background-color: rgba(193, 33, 12, 0.1);
    font-size: 14px;
    line-height: 16.8px;
    color: #636363;
  }

  .input-area:focus {
    background-color: #FFE1E1;
    border-bottom: 1px solid #AC1F08;
  }

  .input-area.one-half {
    width: 48%;
    margin-bottom: 5px;
  }

  .remark-text {
    font-size: 15px;
    color: #9e9e9e;
    display: inline-block;
    line-height: 1.4;
  }

  .input-group {
    display: flex;
  }

  .graph-area {
    background-color: #ffffff;
    border-radius: 10px;
  }
  p.declaration{
    line-height:1.2;
    margin-top: -5%;
  }
  .gragh-area-content{
    max-width: 500px;
    margin: 0 auto;
  }
  .gragh-area-content p{
    color: #C1210C;
    padding-top: 20px;
    font-family: "HelveticaNeueLTStd-Bd";
    line-height: 0;
    text-align: center!important;
  }
  .income{
    border: none;
  }
  .income td:first-child{
    padding: 15px 12px;
    color: #6D6D6D !important; 
    border-bottom: 1px solid #4d4d4d;
  }
  .income td:last-child{
    padding: 15px 12px;
    color: #AC1F08;
    border-bottom: 1px solid #4d4d4d;
  }
  .income th{
    font-family: "HelveticaNeueLTStd-Bd";
    padding: 15px 12px;
    /* padding: 1px 10px; */
    color: #6D6D6D !important;
    border-bottom: 1px solid #4d4d4d;
    line-height: 1.3;
  }
  .income td:first-child,.income th:first-child{
    text-align: left;
    background-color: #ffffff !important;
    width: 70%;
  }

  .theme-dark th, .theme-dark td{
    background-color: transparent !important;
  }
  .income td:last-child,.income th:last-child{
    text-align: right;
    background-color: rgba(218, 218, 217) !important;
    /* background-color: green !important; */
    width: 30%;
  }
  .income tr:last-child td{
    /* font-family: "Montserrat-Bold"; */
  }
  #result_table{
    height: 300px !important;
    padding-bottom: 10px;
  }
  .shadow-huge-box{
    width: 20px;
    height: 20px;
    margin-right: 5px;
    background-color: #C1210C;
    vertical-align: -webkit-baseline-middle;
  }
  /* #reset{
    text-align: right;
  } */
  /* .button-center-medium{
    margin: 0%;
  } */
  .small-width{
    width: 25%!important;
  }
  .half-width{
    width: 50%!important;
    display: flex;
  }
  .half-button{
    width: 50%!important;
  }
  /* .page-content {
    scroll-behavior: smooth;
  } */
  @media(min-width:768px){  
    p.declaration{
      margin-top: -3%;
    }
    .income th{
      font-size: 20px;
    }
    .income td{
      font-size: 20px;
    }

    #divider-result{
      display: flex;
      flex-direction: unset;
    }

    #enter {
      order: 1;
      margin-left: 0px;
    }

    #reset {
      order: 0;
      margin-right: 0px;
    }
  }
  @media(max-width:570px){
    .fac {
      font-size: 11px;
    }

    .fac label {
      padding: 8px 11px;
      min-width: 65px;
      margin-right: 1em;
    }

    .remark-text {
      font-size: 11px;
    }
    .small-width{
      width: 15%!important;
    }
    .half-width{
      width: 85%!important;
      display: flex;
    }
    .half-button{
      width: 50%!important;
    }

    .graph-area-text{
      font-size: 12px;
    }
  }
</style>
<script>
  import $ from 'jquery'
  import Chart from 'chart.js'
  // import { Bar } from 'vue-chartjs'
  export default {
    name: 'Perks',
    mounted() {
      document.querySelector(".header-s").style.display = "block";
      document.querySelector(".header").style.zIndex = "96";

      $(document).ready(function () {
        $("#result").hide();
        $('#reset').on('click',function(){
          $('#amount').val('138000');
          $('#rate').val('20');
          $('#tranditional_rate').val('');
          $('#ilp_rate').val('');
          $(".amount_value").prop("checked", false);
          $(".rate_value").prop("checked", false);
          $('input[name=amount_value][value=138000]').prop('checked', 'checked');
          $('input[name=rate_value][value=20]').prop('checked', 'checked');
         
          $("#result").hide();
        });
        $('#again').on('click',function(){
          $('html, body').animate({scrollTop : 0},800);
          $('#amount').val('138000');
          $('#rate').val('20');
          $('#tranditional_rate').val('');
          $('#ilp_rate').val('');
          $(".amount_value").prop("checked", false);
          $(".rate_value").prop("checked", false);
          $('input[name=amount_value][value=138000]').prop('checked', 'checked');
          $('input[name=rate_value][value=20]').prop('checked', 'checked');
          setTimeout(
            function(){
              $("#result").hide();
            }, 1000);
        });
        $('.amount_value').on('click',function(){
          var value=$(this).val();
          $('#amount').val(value);
        });
        $('.rate_value').on('click',function(){
          var value=$(this).val();
          $('#rate').val(value);
        });
        $('#ilp_rate').on('keyup',function(){
          var value=$(this).val();
          var max=100;
          if(value>max){
            value=max;
            $('#ilp_rate').val(value);
          }
          var other =max-value;
          $('#tranditional_rate').val(other);
        });
        $('#tranditional_rate').on('keyup',function(){
          var value=$(this).val();
          var max=100;
          if(value>max){
            value=max;
            $('#tranditional_rate').val(value);
          }
          var other =max-value;
          $('#ilp_rate').val(other);
        });
        var tl_1=40;
        var tl_2=30;
        var tl_3=20;
        var tl_4=15;
        var tl_5=10;
        var tl_6=10;
        var ilp_1=25;
        var ilp_2=25;
        var ilp_3=18;
        var ilp_4=15;
        var ilp_5=12;
        var ilp_6=12;
        $('#enter').on('click',function(){
        
          var amount=$('#amount').val();
          var rate=$('#rate').val();
          var tranditional_rate=$('#tranditional_rate').val();
          var ilp_rate=$('#ilp_rate').val();

          var new_rate=+rate+ +100;
          

          if(!amount || !rate || !tranditional_rate || !ilp_rate){
            $("#result").hide();
            alert('Looks like you missed something. Please fill in all required fields with valid information.')
          }else{
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#divider-result").offset().top
            }, 2000);

            $("#result").show();
          }
          const options2 = { style: 'currency', currency: 'USD' };
          const numberFormat2 = new Intl.NumberFormat('en-US', options2);
          var total_tl_1=amount*tranditional_rate/100;
          var total_ipl_1=amount*ilp_rate/100;
          var total_1st_commission_1=(total_tl_1*tl_1/100)+(total_ipl_1*ilp_1/100);
          var total_1st_commission_2=(total_tl_1*tl_2/100)+(total_ipl_1*ilp_2/100);
          var total_1st_commission_3=(total_tl_1*tl_3/100)+(total_ipl_1*ilp_3/100);
          var total_1st_commission_4=(total_tl_1*tl_4/100)+(total_ipl_1*ilp_4/100);
          var total_1st_commission_5=(total_tl_1*tl_5/100)+(total_ipl_1*ilp_5/100);
          var total_1st_commission_6=(total_tl_1*tl_6/100)+(total_ipl_1*ilp_6/100);
          var value=numberFormat2.format(total_1st_commission_1.toFixed(0));
          value=value.substring(1);
          $('#1st-year-value').html(value.replace('.00',''));

          var sales_2_yrs=amount*new_rate/100;
          var total_tl_2=sales_2_yrs*tranditional_rate/100;
          var total_ipl_2=sales_2_yrs*ilp_rate/100;
          var total_2nd_commission_1=(total_tl_2*tl_1/100)+(total_ipl_2*ilp_1/100);
          var total_2nd_commission_2=(total_tl_2*tl_2/100)+(total_ipl_2*ilp_2/100);
          var total_2nd_commission_3=(total_tl_2*tl_3/100)+(total_ipl_2*ilp_3/100);
          var total_2nd_commission_4=(total_tl_2*tl_4/100)+(total_ipl_2*ilp_4/100);
          var total_2nd_commission_5=(total_tl_2*tl_5/100)+(total_ipl_2*ilp_5/100);
          var commission_2nd=total_2nd_commission_1+ +total_1st_commission_2;
          var value_2=numberFormat2.format(commission_2nd.toFixed(0));
          value_2=value_2.substring(1);
          $('#2nd-year-value').html(value_2.replace('.00',''));
          // $('#2nd-year-value').html(commission_2nd.toFixed(0));

          var sales_3_yrs=sales_2_yrs*new_rate/100;
          var total_tl_3=sales_3_yrs*tranditional_rate/100;
          var total_ipl_3=sales_3_yrs*ilp_rate/100;
          var total_3rd_commission_1=(total_tl_3*tl_1/100)+(total_ipl_3*ilp_1/100);
          var total_3rd_commission_2=(total_tl_3*tl_2/100)+(total_ipl_3*ilp_2/100);
          var total_3rd_commission_3=(total_tl_3*tl_3/100)+(total_ipl_3*ilp_3/100);
          var total_3rd_commission_4=(total_tl_3*tl_4/100)+(total_ipl_3*ilp_4/100);
          var commission_3rd=total_3rd_commission_1+ +total_2nd_commission_2+ +total_1st_commission_3;
          var value_3=numberFormat2.format(commission_3rd.toFixed(0));
          value_3=value_3.substring(1);
          $('#3rd-year-value').html(value_3.replace('.00',''));
          // $('#3rd-year-value').html(commission_3rd.toFixed(0));

          var sales_4_yrs=sales_3_yrs*new_rate/100;
          var total_tl_4=sales_4_yrs*tranditional_rate/100;
          var total_ipl_4=sales_4_yrs*ilp_rate/100;
          var total_4th_commission_1=(total_tl_4*tl_1/100)+(total_ipl_4*ilp_1/100);
          var total_4th_commission_2=(total_tl_4*tl_2/100)+(total_ipl_4*ilp_2/100);
          var total_4th_commission_3=(total_tl_4*tl_3/100)+(total_ipl_4*ilp_3/100);
          var commission_4th=total_4th_commission_1+ +total_3rd_commission_2+ +total_2nd_commission_3+ +total_1st_commission_4;
          var value_4=numberFormat2.format(commission_4th.toFixed(0));
          value_4=value_4.substring(1);
          $('#4th-year-value').html(value_4.replace('.00',''));
          // $('#4th-year-value').html(commission_4th.toFixed(0));

          var sales_5_yrs=sales_4_yrs*new_rate/100;
          var total_tl_5=sales_5_yrs*tranditional_rate/100;
          var total_ipl_5=sales_5_yrs*ilp_rate/100;
          var total_5th_commission_1=(total_tl_5*tl_1/100)+(total_ipl_5*ilp_1/100);
          var total_5th_commission_2=(total_tl_5*tl_2/100)+(total_ipl_5*ilp_2/100);
          var commission_5th=total_5th_commission_1+ +total_4th_commission_2+ +total_3rd_commission_3+ +total_2nd_commission_4+ +total_1st_commission_5;
          var value_5=numberFormat2.format(commission_5th.toFixed(0));
          value_5=value_5.substring(1);
          $('#5th-year-value').html(value_5.replace('.00',''));
          // $('#5th-year-value').html(commission_5th.toFixed(0));

          var sales_6_yrs=sales_5_yrs*new_rate/100;
          var total_tl_6=sales_6_yrs*tranditional_rate/100;
          var total_ipl_6=sales_6_yrs*ilp_rate/100;
          var total_6th_commission_1=(total_tl_6*tl_1/100)+(total_ipl_6*ilp_1/100);
          var commission_6th=total_6th_commission_1+ +total_5th_commission_2+ +total_4th_commission_3+ +total_3rd_commission_4+ +total_2nd_commission_5+ +total_1st_commission_6;
          var value_6=numberFormat2.format(commission_6th.toFixed(0));
          value_6=value_6.substring(1);
          $('#6th-year-value').html(value_6.replace('.00',''));
          // $('#6th-year-value').html(commission_6th.toFixed(0));

          var total_all=total_1st_commission_1+ +commission_2nd+ +commission_3rd+ +commission_4th+ +commission_5th+ +commission_6th;
          total_all=numberFormat2.format(total_all.toFixed(0));
          total_all=total_all.substring(1);
          $('#total-value').html(total_all.replace('.00',''));
          // $('#total-value').html(total_all.toFixed(0));
          $('#result_table').remove(); // this is my <canvas> element
          $('.gragh-area-content .content').append('<canvas class="chart" id="result_table"/>');
          var canvas = document.querySelector('#result_table');
          setTimeout(
            function() 
            {
          new Chart(canvas, {
            height:300,
              type: 'bar',
              data: {
                labels: ["1st", "2nd", "3rd", "4th", "5th", "6th"],
                datasets: [{
                  label: "amount",
                  backgroundColor: [
                    '#F7C274',
                    '#B6BC9C',
                    '#A4A4C0',
                    '#E4B9CC',
                    '#93A897',
                    '#B6BC9C'
                  ],
                  // data: [2100,3200,4300,6600,8000,10000]
                  data: [total_1st_commission_1, commission_2nd, commission_3rd, commission_4th,commission_5th,commission_6th]
                }]
              },
              options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                  display: false,
                  position: 'bottom',
                  labels: {
                    fontSize: 13,
                    padding: 15,
                    boxWidth: 12,
                    color: '#C1210C'
                  },
                },
                "tooltips": {
                  enabled: false
                },
                hover: {
                  animationDuration: 0
                },
                "animation": {
                    "duration": 2000,
                    "onComplete": function() {
                      var chartInstance = this.chart,
                        ctx = chartInstance.ctx;
      
                      ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                      ctx.textAlign = 'center';
                      ctx.textBaseline = 'bottom';
                      ctx.fillStyle = "#C1210C";
      
                      this.data.datasets.forEach(function(dataset, i) {
                        var meta = chartInstance.controller.getDatasetMeta(i);
                        meta.data.forEach(function(bar, index) {
                          var value=numberFormat2.format(dataset.data[index].toFixed(0));
                          value=value.substring(1);
                          var data = value.replace('.00','');
                          ctx.fillText(data, bar._model.x, bar._model.y - 5);
                        });
                      });
                    }
                },
                title: {
                  display: false
                },
                scales: {
                      yAxes: [{
                          ticks: {
                              display: false,
                              beginAtZero: true,
                              stepSize: commission_6th/4,
                              max : commission_6th+(commission_6th*10/100),  
                          },
                          gridLines: {
                            drawBorder: false,
                            lineWidth:2
                          }
                      }],
                      xAxes: [{
                          ticks: {
                              fontColor: "#C1210C",
                          },
                          gridLines: {
                              display : false,
                          },
                          scaleLabel: {
                            display: true,
                            labelString: 'Year',
                            fontColor: "#C1210C",
                          },
                      }]
                  }
              },
            });
            }, 2000);

          document.getElementById('result_table').style.height='250px';
          document.getElementById('result_table').style.paddingBottom='10px';
        });

      });
    }
  }
</script>